<template>
  <div class="standard-page">
    <div class="detail-view-header">
      Merchant Account Detail
    </div>
    <div class="detail-view-deck">
      <b-card class="detail-view-info-card">
        <LabeledInfo label="Bank Name" :value="merchantAccount.bank_name" />
        <LabeledInfo
          label="Account Type"
          :value="merchantAccount.bank_account_type"
        />
        <LabeledInfo
          label="Category Code"
          :value="merchantAccount.category_code"
        />
        <LabeledInfo
          label="Bank Account Number"
          :value="merchantAccount.bank_account_number"
        />
        <LabeledInfo
          label="Bank Routing Number"
          :value="merchantAccount.bank_routing_number"
        />
        <LabeledInfo
          label="Propay Account Number"
          :value="merchantAccount.propay_account_number"
        />
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo label="Address" :value="merchantAccount.address" />
        <LabeledInfo label="Address ln 2" :value="merchantAccount.address2" />
        <LabeledInfo label="City" :value="merchantAccount.city" />
        <LabeledInfo label="Postal Code" :value="merchantAccount.postal_code" />
        <LabeledInfo
          label="State/Province"
          :value="merchantAccount.state_province"
        />
        <LabeledInfo label="Country" :value="merchantAccount.country" />
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo label="ID" :value="merchantAccount.id" />
      </b-card>
    </div>
  </div>
</template>

<script>
import endpoints from '@/utils/endpoints.js'

export default {
  data() {
    return {
      merchantAccount: {}
    }
  },
  mounted() {
    this.getMerchantAccount()
  },
  methods: {
    getMerchantAccount() {
      this.axios
        .get(
          endpoints.retrieveMerchantAccount(
            this.$route.params.merchantID,
            this.$route.params.merchantAccountID
          )
        )
        .then(res => {
          this.merchantAccount = res.data
        })
        .catch(err => {
          console.log('error', err)
        })
    }
  }
}
</script>
